export enum ReplenishmentStrategy {
  LEAN = "LEAN",
  MEDIUM = "MEDIUM",
  HIGH_BUFFER = "HIGH_BUFFER",
  DYNAMIC = "DYNAMIC",
}
